import { BrowserRouter, Route, Routes } from "react-router-dom";
import PrivateRoutes from "./module/private/PrivateRoutes";
import PublicRoutes from "./module/public/PublicRoutes";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/auth/*" element={<PublicRoutes />} />
        <Route path="/appversion/*" element={<PublicRoutes />} />
        <Route path="/*" element={<PrivateRoutes />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
